<script setup>
import { ref, computed } from 'vue'
import { Gallery } from '@lib/pp-shop-lib/components';
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@lib/pp-shop-lib/stores';
import { _ } from 'lodash'
import { glob, logger, ppapiClient, psModal } from '@lib/pp-shop-lib/helpers'
import { useI18n } from 'vue-i18n';

defineOptions({
    name: 'UserMediaView'
})

const authStore = useAuthStore()
const { t } = useI18n();

const router = useRouter()
const route = useRoute()
const queryParams = route.query;

function normalizeTopsQuery(tops) {
    const topsList = Array.isArray(tops) ? tops : String(tops || '').split(',')

    return topsList
        .map((top) => String(top || '').trim())
        .filter((top) => top.indexOf("media/") == 0 || top.indexOf("images/") == 0)
}

async function openTopsProductSelector(tops) {
    const topsList = normalizeTopsQuery(tops)
    if (topsList.length == 0) return

    const responses = await Promise.allSettled(
        topsList.map((top) => ppapiClient.get("users/private/" + top))
    )
    const mediaItems = responses
        .map((result, index) => {
            if (result.status == 'fulfilled') return result.value.data()
            logger.warn(['tops media not found', topsList[index], result.reason])
            return null
        })
        .filter(Boolean)
    if (mediaItems.length == 0) return

    psModal({
        usePgrId: 4,
        layout: 'compact',
        useMedia: mediaItems,
    })
}

if (queryParams.tops) {
    openTopsProductSelector(queryParams.tops)
}

if (queryParams.connect) {
    authStore.setSessionId(queryParams.connect)
    const mercure = glob("mercure")
    // Sessionwechsel zuerst am Hub autorisieren, dann den Status senden.
    void mercure.connect(1).then(() => {
        mercure.publish("state","state",'{"connected":1}')
    })
}

let showUpload = 0
if (queryParams.upload) {
    showUpload = 1
}

// Update counter
const uc = ref(0)

const selectedMedia = ref([])


// aktueller Pfad ohne Parameter
const basePath = ref(_.trimEnd(route.matched[route.matched.length-1].path.split(":")[0],"/"))
basePath.value += "/"

// Der Galeriepfad ist als Parameter an den Basispfad angehängt
// galleryPath ist eine Liste mit allen Verzeichnissen im Pfad (Für Breadcrumbsdarstellung)

const galleryPath = computed(() => {
    let gp = []
    uc.value // Dieser wert trigger neuberechnung bei Änderung von ppShop.folder
    gp.push({path:"/",name:t('mediaFiles.inbox'),urlpath:""})
    if (!route.params.gallerypath || route.params.gallerypath.length === 0) return gp
    let path =  "/"
    let urlpath = ""
    // gallerypath ist bereits ein Array bei Catchall-Parameter
    const pathParts = Array.isArray(route.params.gallerypath) 
        ? route.params.gallerypath 
        : route.params.gallerypath.split("/")
    
    pathParts.forEach((dir) => {
        if (!dir) return // Überspringe leere Teile
        path += dir + "/"
        urlpath += (urlpath ? "/" : "") + dir
        gp.push({path:path,name:folderName({path:path,name:dir}), urlpath:urlpath})
    })

    return gp
})

function updatePath() {
    uc.value++
}

function updateSelectedMedia(data) {
    selectedMedia.value = data
}

function goTo(urlpath) {
    router.push(basePath.value  + urlpath) 
}

function folderName(dir) {

    let fld = {}
    if (glob("folder")) {
        fld = glob("folder").value.get(dir.path)
    }

    if (fld?.name) return fld.name

    return dir.name

}
</script>

<template>
   
        <h4 class="uk-card-title">{{ $t('nav.files') }} 
            <span class="bc-dir">
                <ul class="uk-breadcrumb">
                    <li v-for="dir in galleryPath" :key="dir.path"><a href="#" @click="goTo(dir.urlpath)">{{ dir.name }}</a></li>
                </ul>
            </span>
        </h4>
        
        <Gallery :setup="{showUpload:showUpload, basePath:basePath}" @selected-media="updateSelectedMedia" @folders-changed="updatePath"></Gallery>
 
</template>

<style lang="scss" scoped>

.bc-dir ul {
    display: inline-block;
  font-size: 0.7em;
  margin-left: 30px;
}

.expand {
    transition: height 300ms cubic-bezier(0.3, 0, 0.6, 1);
}

.gallery .image {
    float: left;
    margin: 2px;
    border: 1px solid #fff;
}

.gallery .image.selected {
    border: 1px solid #39f;
}

.gallery .image:hover {
    background-color: #ffffff;
    border-color: rgb(94, 94, 94);
}

.img-checked {
    background-color: #39f;
    position: absolute;
    border-radius: 50%;
    border: 1px solid #fff;
    width: 20px;
    height: 20px;
    margin-top: -4px;
    margin-left: -4px;
    color: #fff;
}

.img-checked i {
    vertical-align: super;
}
</style>